import { computed, ref } from 'vue'
import { auth } from '@/plugins'
import { Company, CompanyRecord } from '@/plugins/companySelection/types'

const selectedCompanyId = ref<string | null>(null)
const selectedCompany = computed(() => {
  return companies.value.find((company) => company.id === selectedCompanyId.value) ?? null
})
const companies = ref<Company[]>([])

export function useCompanies() {
  const { getUserProfile } = auth.useAuthentication()

  const setCompanies = (dictionary: CompanyRecord) => {
    const userProfile = getUserProfile()
    const roleClaim = userProfile?.role

    const normalizeRoles = (claim: any): string[] => {
      if (Array.isArray(claim)) {
        return claim.filter((role) => typeof role === 'string')
      }
      if (typeof claim === 'string' && claim.trim() !== '') {
        return [claim]
      }
      return []
    }

    const roles = normalizeRoles(roleClaim)
    const companyPrefix = 'General:Company_'

    const availableCompanies = roles
      .filter((role) => role.startsWith(companyPrefix))
      .map((role) => {
        const companyId = role.substring(companyPrefix.length)
        const companyData = dictionary[companyId]
        return companyData ? { id: companyId, ...companyData } : null
      })
      .filter((company): company is Company => company !== null)
      .sort((a, b) => a.name.localeCompare(b.name))

    companies.value = availableCompanies
  }

  return {
    setCompanies,
    selectedCompanyId,
    selectedCompany,
    companies
  }
}
